import { useState, useCallback } from 'react'
import { getSalesTeam } from '../api'
import { selectSalesTeamById } from '../slice'
import { useAppSelector, useAppDispatch } from '@user/store/hooks'

type State = {
  teamId: number
  status: 'idle' | 'pending' | 'success' | 'fail'
}

export function useGetSalesTeam(includeUsers?: boolean) {
  const dispatch = useAppDispatch()

  const [state, setState] = useState<State>(() => ({
    teamId: -1,
    status: 'idle',
  }))

  const team = useAppSelector((store) =>
    selectSalesTeamById(store, state.teamId),
  )

  const setTeamId = useCallback(
    async (teamId?: number) => {
      if (!teamId) return setState({ teamId: -1, status: 'idle' })

      setState({ teamId, status: 'pending' })

      const result = await dispatch(getSalesTeam({ id: teamId, includeUsers }))

      setState({
        teamId,
        status: getSalesTeam.fulfilled.match(result) ? 'success' : 'fail',
      })
    },
    [dispatch, includeUsers],
  )

  return {
    team,
    setTeamId,
    status: state.status,
  }
}
